/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsUpdateSchedule } from "../../funcs/llmEvalsUpdateSchedule.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateEvalScheduleRequest$inboundSchema,
};

export const tool$llmEvalsUpdateSchedule: ToolDefinition<typeof args> = {
  name: "llm-evals-update-schedule",
  description: `Update an eval schedule

Updates an eval schedule's cadence, run config, webhook, overlap policy, or enabled state.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsUpdateSchedule(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
